import { render, staticRenderFns } from "./SideSurvey.vue?vue&type=template&id=9b2aeec8&lang=html&"
import script from "./SideSurvey.vue?vue&type=script&lang=js&"
export * from "./SideSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports